import React, { useMemo, useState } from "react";
import Calendar from "../Layout/Calendar";

function CalendarModal({ onClose, onDateSelect, initialDate }) {
  const parsedInitialDate = useMemo(() => {
    if (!initialDate) return new Date();
    const dt = new Date(initialDate);
    return Number.isNaN(dt.getTime()) ? new Date() : dt;
  }, [initialDate]);

  const [currentDate, setCurrentDate] = useState(parsedInitialDate);
  const [selectedDate, setSelectedDate] = useState(parsedInitialDate.getDate());

  const handleSelectDate = (date) => {
    if (typeof onDateSelect === "function") {
      onDateSelect(date);
    }
    if (typeof onClose === "function") {
      onClose();
    }
  };

  return (
    <Calendar
      currentDate={currentDate}
      selectedDate={selectedDate}
      setCurrentDate={setCurrentDate}
      setSelectedDate={setSelectedDate}
      onSelectDate={handleSelectDate}
    ></Calendar>
  );
}

export default CalendarModal;
